import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { useAPIGetRegistrationEntryLink } from '../../../api/apiHooks/useAPIGetRegistrationEntryLink'
import i18n from '../../../i18n/i18n'
import { ResidentAppLocale } from '../../../../common/validations'
import { RegistrationState } from './index'

interface Data {
  teliaLink: string
  loading: boolean
}

export const RegisterDataLoader = ({
  authType,
  children,
}: {
  authType: RegistrationState['authType']
  children: (data: Data) => React.ReactNode
}) => {
  const [params] = useSearchParams()

  const { mutate, data, isSuccess, isError } = useAPIGetRegistrationEntryLink(
    i18n.language ?? ResidentAppLocale.FI,
    params.get('resetOldUser') === 'true'
  )

  useEffect(() => {
    if (authType === 'telia') {
      mutate()
    }
  }, [authType, mutate])

  return children({
    teliaLink: data?.link ?? '',
    loading: !isSuccess && !isError,
  })
}
